import request from '@/utils/request'

let Consultation_dlApi = {

  /*代理咨询列表*/
  list(data) {
    return request._post('/shop/plus.consultation_dl.Index/index', data);
},
/*添加代理咨询*/
add(data) {
    return request._post('/shop/plus.consultation_dl.Index/add', data);
},
/*修改代理咨询*/
edit(data) {
    return request._post('/shop/plus.consultation_dl.Index/edit', data);
},
/*删除代理咨询*/
del(data) {
    return request._post('/shop/plus.consultation_dl.Index/del', data);
},
/*代理咨询详情*/
detail(data) {
  return request._post('/shop/plus.consultation_dl.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.consultation_dl.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.consultation_dl.Setting/getSetting', data, errorback);
    },
}
export default Consultation_dlApi;



// WEBPACK FOOTER //
// ./src/api/consultation_dl.js